var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFacebookJatMed({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 9,
    height: 17,
    viewBox: "0 0 9 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.04201 3.87998H8.10401V0.833984H5.67901V0.845985C2.74501 0.948985 2.14101 2.60098 2.08801 4.33398H2.08201V5.85398H0.0830078V8.83899H2.08201V16.834H5.09601V8.83899H7.56601L8.04201 5.85398H5.09701V4.93498C5.09801 4.34998 5.48801 3.87998 6.04201 3.87998Z",
    fill: "#32976B"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFacebookJatMed);
export default __webpack_public_path__ + "static/media/facebook_jat-med.ce4bf2e2a94a6bba40a6d54294a1087f.svg";
export { ForwardRef as ReactComponent };